import { load } from "@fingerprintjs/fingerprintjs";

export const getIdentifier = async () => {
    try {
        const fingerprintjs = await load();
        return await fingerprintjs.get();
    } catch (error) {
        return null;
    }
};